import { useMemo } from 'react';
import { getClaimFeatureAccess } from 'shared/lib/authUtils';

/**
 * Claim payment-method feature access (Cashless / Reimbursement) sourced from
 * GET /me company_features (persisted in localStorage.company).
 *
 * Non-reactive by design: company access only changes on login / token refresh,
 * both of which trigger a full reload — matching the existing findMenuAccess
 * pattern. Empty deps are therefore correct.
 *
 * @returns {{ isCashlessActive: boolean, isReimbursementActive: boolean, isAnyClaimFeatureActive: boolean }}
 */
export function useClaimFeatureAccess() {
  return useMemo(() => getClaimFeatureAccess(), []);
}

export default useClaimFeatureAccess;
